// ACTIVATE:
// invoke initFormFieldsToggle() in main.ts if you need to add this hide / show feature for form fields
// EXAMPLE:
// you need to show additional fields if a specific option is selected
// and hide other non-related-fields
// HOW TO DO IT:
// add [data-toggler] to all the select fields, that make some extra fields appear
const initFormFieldsToggle = () => {
    const contactFormsArray = document.querySelectorAll("[contact-form]");
    if (contactFormsArray && contactFormsArray.length > 0) {
        contactFormsArray.forEach((form) => {
            const togglerArray = form.querySelectorAll("[data-toggler]");
            const elementsToBeToggledArray = document.querySelectorAll("[data-form-toggle-type]");
            togglerArray && togglerArray.length > 0 && togglerArray.forEach((toggler) => {
                //give it a first run to show correct data only
                toggleFormFields(elementsToBeToggledArray, toggler);
                //bind the function to the change event
                toggler.addEventListener("change", () => {
                    toggleFormFields(elementsToBeToggledArray, toggler);
                });
            });
        });
    }
};
//IF YOU WANT TO INSERT A NEW "data-form-toggle-type", THIS CODE HANDLES ONLY SINGLE WORDS
//SO MAKE THE VALUE OF THE OPTION AND THE ATTR BE JUST ONE WORD
//EXAMPLE: 
// OK => NEWTYPE, newtype, NewType
// NOT OK => NEW-TYPE, NEW TYPE
//IF YOU WANT AN ELEMENT TO BE AVAILABLE FOR MORE THAN ONE TYPE OF OPTION
//THEN SEPARE THE TYPES WITH ";"
//LIKE THIS "data-form-toggle-type="type1;type2"
const toggleFormFields = (array, selectToggler) => {
    array.forEach((element) => {
        if (element.getAttribute("data-form-toggle-type").split(";").includes(selectToggler.value.toLowerCase())) {
            element.classList.remove("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.removeAttribute('disabled');
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.removeAttribute('disabled');
                });
            }
        }
        else {
            element.classList.add("hidden");
            if (element instanceof HTMLInputElement || element instanceof HTMLSelectElement) {
                element.disabled = true;
            }
            else {
                element.querySelectorAll("input, select").forEach((input) => {
                    input.disabled = true;
                });
            }
        }
    });
};
//LOAD SCRIPTS (RECAPTCHA ETC) ONLY WHEN THE USER IS ON THE FORM
//TO IMPROVE CORE WEB VITALS
// the IntersectionObserver is a js native function that exploits the "observable pattern"
// and gives us an event when an html element enters the users's viewport.
const initFormsExternalScripts = () => {
    // instance new observer (event emitter)
    const observer = new IntersectionObserver((entries) => {
        //function that triggers once the event is observed
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initIubendaProof();
                initRecaptcha();
            }
        });
    });
    //observe (event subscriber / obsever)
    contactForms.forEach((element) => {
        observer.observe(element);
    });
};
